function scrollToTheTop( event ) {
    event.preventDefault();
    jQuery('html, body').animate({ scrollTop: 0 }, 1000);
}

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", function () {
        var buttonToTheTop = document.querySelector('button.to-the-top');
        
        if ( buttonToTheTop != null ) {
            buttonToTheTop.addEventListener('click', scrollToTheTop);
        }
    }, false);
} else {
    window.onload = function () {
        init_footer();
    };
}
